// services/StudentIdCardService.js
import axiosInstance from "./AxiosInstance";

const API_URL = "/idcard";

export const getStudentIdCard = async (email = null) => {
  const url = email ? `${API_URL}?email=${email}` : API_URL;
  const response = await axiosInstance.get(url);
  return response.data;
};